import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function   Mumbaitojaipurtaxi() {



  const cardData = {
    keyword: " Mumbai to Jaipur Taxi ",


"headingDescription": "Royal Route Cab offers reliable and comfortable Mumbai to Jaipur taxi services, ensuring a safe, smooth, and hassle-free long-distance journey for families, business travelers, and group passengers. Jaipur, also known as the Pink City, is the capital of Rajasthan and is famous for its royal palaces, forts, vibrant markets, and rich cultural heritage, making it one of the most popular travel destinations from Mumbai. Our professional drivers and well-maintained vehicles ensure a stress-free travel experience throughout the journey. The Mumbai to Jaipur route covers approximately 1,150 to 1,200 km via NH48 and takes around 18 to 22 hours depending on traffic, road conditions, and stoppages. We offer flexible booking options including one-way trips, round trips, and customized travel plans with transparent pricing and no hidden charges. Our fleet includes air-conditioned sedans, spacious SUVs, luxury cars, and Tempo Travellers suitable for all types of travelers. With easy online booking and 24/7 customer support, Royal Route Cab is your trusted partner for Mumbai to Jaipur travel.",

"topPlaces": [
  {
    "title": "Hawa Mahal",
    "description": "Hawa Mahal, also known as the Palace of Winds, is one of Jaipur’s most iconic landmarks. Built with pink sandstone, it features hundreds of small windows designed for royal women to observe street life while remaining unseen. Its unique architecture and photogenic façade make it a must-visit attraction."
  },
  {
    "title": "Amber Fort",
    "description": "Amber Fort is a magnificent hilltop fort located near Jaipur, known for its grand architecture, mirror work halls, courtyards, and elephant rides. It offers panoramic views of the surrounding hills and Maota Lake, showcasing Rajasthan’s royal history and craftsmanship."
  },
  {
    "title": "City Palace Jaipur",
    "description": "City Palace is a royal residence that blends Mughal and Rajasthani architecture. It houses museums, courtyards, and royal artifacts, offering visitors a glimpse into Jaipur’s regal past and the lifestyle of the Maharajas."
  },
  {
    "title": "Jantar Mantar",
    "description": "Jantar Mantar is a UNESCO World Heritage Site featuring ancient astronomical instruments built by Maharaja Sawai Jai Singh II. It is one of the largest observatories in the world and demonstrates advanced scientific knowledge of ancient India."
  },
  {
    "title": "Nahargarh Fort",
    "description": "Nahargarh Fort is located on the Aravalli hills and offers stunning sunset views of Jaipur city. It was originally built for defense and now serves as a popular viewpoint and tourist attraction."
  },
  {
    "title": "Jaigarh Fort",
    "description": "Jaigarh Fort is known for housing the world’s largest cannon on wheels, Jaivana Cannon. It offers strong military architecture, underground passages, and panoramic views of Amber Fort and Jaipur city."
  },
  {
    "title": "Jal Mahal",
    "description": "Jal Mahal, or Water Palace, is a beautiful palace located in the middle of Man Sagar Lake. It appears to float on water and is a stunning example of Rajput architecture, especially beautiful during sunset."
  },
  {
    "title": "Albert Hall Museum",
    "description": "Albert Hall Museum is the oldest museum in Rajasthan, showcasing artifacts, paintings, sculptures, and Egyptian mummy exhibits. Its Indo-Saracenic architecture is beautifully illuminated at night."
  },
  {
    "title": "Birla Mandir Jaipur",
    "description": "Birla Mandir is a modern white marble temple dedicated to Lord Vishnu and Goddess Lakshmi. It offers a peaceful spiritual atmosphere along with beautifully carved architecture and gardens."
  },
  {
    "title": "Johari Bazaar",
    "description": "Johari Bazaar is a famous shopping destination in Jaipur known for jewelry, gemstones, handicrafts, and traditional Rajasthani attire. It is one of the best places to experience local culture and shopping."
  }
],






services: [
  {
    name: "Mumbai to Jaipur Cab",
    description: "Mumbai to Jaipur cab service provides comfortable and reliable long-distance travel between Mumbai and Jaipur. It is ideal for family trips, business travel, and tourist journeys. Professional drivers and well-maintained vehicles ensure a safe and smooth ride. It offers convenient door-to-door transportation."
  },
  {
    name: "Mumbai to Jaipur Taxi",
    description: "Mumbai to Jaipur taxi service offers affordable and comfortable intercity travel for passengers. It ensures a hassle-free journey with experienced drivers. Suitable for both solo and group travel. It guarantees safe and timely transportation."
  },
  {
    name: "Mumbai to Jaipur Cab Service",
    description: "Mumbai to Jaipur cab service provides reliable outstation travel with multiple vehicle options. Customers can choose sedans, SUVs, or premium cars based on their needs. It ensures a smooth and comfortable long-distance journey. It is ideal for planned trips."
  },
  {
    name: "Mumbai to Jaipur Taxi Service",
    description: "Mumbai to Jaipur taxi service offers professional and punctual transportation for long-distance travel. It focuses on comfort, safety, and affordability. Well-maintained vehicles ensure a pleasant journey. It is suitable for all types of travelers."
  },
  {
    name: "Cab from Mumbai to Jaipur",
    description: "Cab from Mumbai to Jaipur provides easy booking and reliable travel options for intercity routes. It offers flexible vehicle choices and transparent pricing. Ideal for one-way and round trips. It ensures a smooth travel experience."
  },
  {
    name: "Taxi from Mumbai to Jaipur",
    description: "Taxi from Mumbai to Jaipur offers convenient and budget-friendly travel solutions for long routes. It includes professional drivers and clean vehicles. Suitable for family and business trips. It ensures safe and comfortable travel."
  },
  {
    name: "Mumbai to Jaipur Cab Booking",
    description: "Mumbai to Jaipur cab booking allows users to reserve taxis easily through quick and simple booking methods. It provides instant confirmation and multiple cab options. Ideal for planned and urgent travel. It ensures a seamless booking experience."
  },
  {
    name: "Mumbai to Jaipur Taxi Booking Online",
    description: "Mumbai to Jaipur taxi booking online enables customers to book cabs instantly through digital platforms. It offers transparent pricing and fast confirmation. It is convenient for long-distance travel planning. It ensures reliable service access."
  },
  {
    name: "Mumbai to Jaipur Cab Price",
    description: "Mumbai to Jaipur cab price varies based on vehicle type, route, and travel duration. It offers affordable options for different budgets. Transparent pricing ensures no hidden charges. It helps in effective trip planning."
  },
  {
    name: "Mumbai to Jaipur Taxi Fare",
    description: "Mumbai to Jaipur taxi fare is calculated based on distance and cab category. It provides clear and upfront pricing for customers. It is cost-effective for long-distance travel. It ensures transparency and affordability."
  },
  {
    name: "Mumbai to Jaipur One Way Cab",
    description: "Mumbai to Jaipur one way cab service is ideal for travelers who need only drop transportation. It eliminates return fare charges and reduces cost. It offers comfortable long-distance travel. It ensures a budget-friendly journey."
  },
  {
    name: "Mumbai to Jaipur Round Trip Taxi",
    description: "Mumbai to Jaipur round trip taxi service provides complete travel solutions for both onward and return journeys. It is suitable for planned trips and tourism. Professional drivers ensure timely service. It guarantees a hassle-free experience."
  },
  {
    name: "Mumbai to Jaipur Innova Cab",
    description: "Mumbai to Jaipur Innova cab is ideal for group travel and family trips with spacious seating and comfort. It ensures a smooth and safe long-distance journey. Perfect for extended travel. It offers reliable transportation."
  },
  {
    name: "Mumbai to Jaipur Ertiga Cab",
    description: "Mumbai to Jaipur Ertiga cab provides comfortable and economical travel for small groups. It offers good mileage and seating comfort. Suitable for long-distance journeys. It ensures a smooth travel experience."
  },
  {
    name: "Mumbai to Jaipur Sedan Cab",
    description: "Mumbai to Jaipur sedan cab offers affordable and comfortable travel for individuals and small families. It provides a smooth ride for long distances. Ideal for budget-friendly travel. It ensures safe transportation."
  },
  {
    name: "Mumbai to Jaipur SUV Taxi",
    description: "Mumbai to Jaipur SUV taxi provides spacious and premium travel options for groups and families. It ensures comfort, safety, and reliability for long journeys. Suitable for rough and long routes. It guarantees a premium experience."
  }
],

tableData: [
  ["Mumbai to Jaipur Cab", "Mumbai to Jaipur Taxi"],
  ["Mumbai to Jaipur Cab Service", "Mumbai to Jaipur Taxi Service"],
  ["Cab from Mumbai to Jaipur", "Taxi from Mumbai to Jaipur"],
  ["Mumbai to Jaipur Cab Booking", "Mumbai to Jaipur Taxi Booking Online"],
  ["Mumbai to Jaipur Cab Price", "Mumbai to Jaipur Taxi Fare"],
  ["Mumbai to Jaipur One Way Cab", "Mumbai to Jaipur Round Trip Taxi"],
  ["Mumbai to Jaipur Innova Cab", "Mumbai to Jaipur Ertiga Cab"],
  ["Mumbai to Jaipur Sedan Cab", "Mumbai to Jaipur SUV Taxi"]
],


whychoose: [
  {
    WhyChooseheading: "Comfortable Mumbai to Indore Travel",
    WhyChoosedescription: "Royal Route Cabs offers a smooth and comfortable Mumbai to Indore cab service, ideal for business trips, family travel, and long-distance journeys."
  },
  {
    WhyChooseheading: "Experienced Long-Distance Drivers",
    WhyChoosedescription: "Our drivers are highly experienced on Mumbai to Indore routes, ensuring safe driving, proper navigation, and timely arrival."
  },
  {
    WhyChooseheading: "Transparent Pricing with No Hidden Charges",
    WhyChoosedescription: "Royal Route Cabs provides clear and upfront pricing including tolls, driver allowance, and all travel costs with no hidden charges."
  },
  {
    WhyChooseheading: "24/7 Cab Service Availability",
    WhyChoosedescription: "Our Mumbai to Indore cab service operates 24/7, allowing flexible travel anytime as per your schedule."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles are fully air-conditioned, well-maintained, and regularly cleaned to ensure a comfortable long-distance travel experience."
  },
  {
    WhyChooseheading: "One Way & Round Trip Options",
    WhyChoosedescription: "Choose from one-way cab service, round-trip bookings, or multi-day travel options for Indore trips."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "We offer sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta, and Tempo Travellers for individuals and group travel."
  },
  {
    WhyChooseheading: "Trusted Intercity Cab Service",
    WhyChoosedescription: "Royal Route Cabs is trusted by travelers for Mumbai to Indore cab bookings due to punctual service, professional drivers, and reliable experience."
  }
]

};

const faqData = [
  { question: "Do you provide Mumbai to Indore cab service?", answer: "Yes, Royal Route Cabs offers reliable cab services from Mumbai to Indore for both one-way and round trips." },
  { question: "What is the distance between Mumbai and Indore?", answer: "The distance is approximately 580 to 600 km and takes around 10 to 12 hours depending on route and traffic." },
  { question: "Is cab service available 24 hours?", answer: "Yes, our Mumbai to Indore cab service operates 24/7." },
  { question: "Which vehicles are available for this route?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, Innova Crysta, and Tempo Travellers." },
  { question: "Can I book a one-way cab?", answer: "Yes, we provide both one-way and round-trip cab services." },
  { question: "Are vehicles air-conditioned?", answer: "Yes, all vehicles are fully air-conditioned for comfortable travel." },
  { question: "Do you provide doorstep pickup?", answer: "Yes, we offer pickup from home, hotel, and airport anywhere in Mumbai." },
  { question: "Is advance booking required?", answer: "Advance booking is recommended for long-distance trips like Mumbai to Indore." },
  { question: "Do you provide night travel service?", answer: "Yes, we provide safe night travel with experienced drivers." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly for passenger safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rakesh Verma",
    feedback: "The Mumbai to Jaipur journey with Royal Route Cabs was very comfortable and well-organized. The driver was experienced and made the long trip feel safe and smooth.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Poonam Soni",
    feedback: "Very good service for our Mumbai to Jaipur taxi booking. The cab was clean, and the entire travel experience was hassle-free with timely pickup and drop.",
    rating: 5
  }
];
















  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman taxi", link: "Mumbai-to-Daman-Taxi" },
    { place: "/images/keyword/26.jpg", text: "Mumbai to Vapi cab", link: "Mumbai-to-Vapi-Cab" },
    { place: "/images/keyword/27.jpg", text: "Mumbai to Bangalore cab", link: "Mumbai-to-Bangalore-Cab" }
  ];




const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Jaipur Taxi",
  "image": "https://www.royalroutecabs.com/assets/images/mumbai-to-jaipur-cab.jpg", // replace if needed
  "description": "Book Mumbai to Jaipur taxi with Royal Route Cabs for a safe, comfortable, and long-distance journey. Choose from sedan, SUV, Innova, and luxury cars for one-way and round-trip taxi services with 24x7 availability and experienced drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Royal Route Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.7",
    "ratingCount": "3200",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "9000", // adjust if needed
    "availability": "https://schema.org/InStock",
    "url": "https://www.royalroutecabs.com/mumbai-to-jaipur-taxi"
  }
};










  return (
    <div>
<Helmet>
  <title>Mumbai to Jaipur Taxi | Call:- +91 9529877342 | Best Outstation Cab Service</title>

  <meta
    name="description"
    content="Book Mumbai to Jaipur taxi at best price with Royal Route Cabs. One-way & round-trip cab service with sedan, SUV, Innova & luxury cars. Safe, reliable & 24x7 available."
  />

  <meta
    name="keywords"
    content="mumbai to jaipur taxi, mumbai to jaipur cab, mumbai to jaipur cab service, mumbai to jaipur taxi service, cab from mumbai to jaipur, taxi from mumbai to jaipur, mumbai to jaipur cab booking, mumbai to jaipur taxi booking online, mumbai to jaipur cab price, mumbai to jaipur taxi fare, mumbai to jaipur one way cab, mumbai to jaipur round trip taxi, mumbai to jaipur innova cab, mumbai to jaipur ertiga cab, mumbai to jaipur sedan cab, mumbai to jaipur suv taxi, cheap mumbai to jaipur cab, best mumbai to jaipur taxi service"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <div
        className="breadcrumb-wrapper section-padding bg-cover"
        style={{ backgroundImage: "url('/img/breadcrumb-bg.jpeg')" }}
      >
        <div className="container-fluid">
          <div className="page-heading">
            <h1 className="text-center">{cardData.keyword}</h1>
          </div>
        </div>
      </div>














      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/24.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Royal Route Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


          <div className="keyword-grid">
  {cardData.tableData.flat().map((keyword, index) => (
    <div key={index} className="keyword-item">
      <span className="keyword-bullet">-</span>
      {keyword}
    </div>
  ))}
</div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title text-white">
                  Why Choose <span>Royal Route Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Royal Route Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529877342" className="pc-call">+91 9529877342</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529877342"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529877342" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@royalroutecabs.com" className="pc-email">
                      booking@royalroutecabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Royal Route Cab</strong><br />
                      Shop Number 57, Prabhat Colony Opp. Panbai International School Vimladevi Road,Santacruz(E) Mumbai Maharashtra-400055.


                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitojaipurtaxi;